import whatsapp from './whatsapp';
import voice from './voice';

export default {
  whatsapp,
  voice,
};
